import React from "react";
import { AlertTriangle, X } from "lucide-react";

const DataLossWarningDialog = ({ isOpen, onCancel, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50">
            <div
                className="bg-card rounded-lg shadow-xl w-full max-w-md p-6 mx-4 border-0 dark:border-2 dark:border-border"
                data-popup-panel
            >
                <div className="flex items-start mb-4">
                    <div className="flex-shrink-0 mr-3">
                        <AlertTriangle className="h-6 w-6 text-amber-500" />
                    </div>
                    <div className="flex-1">
                        <h3 className="text-lg font-medium text-foreground">Unsaved Changes</h3>
                        <div className="mt-2">
                            <p className="text-sm text-muted-foreground">
                                You have unsaved changes. Are you sure you want to leave this page?
                                Your changes will be lost.
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={onCancel}
                        className="ml-3 flex-shrink-0 text-muted-foreground hover:text-muted-foreground"
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>
                <div className="flex justify-end gap-3">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-sm font-medium text-foreground bg-muted rounded-md hover:bg-muted focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                        Leave Page
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DataLossWarningDialog;
